import * as r from 'ramda';
import * as ra from 'ramda-adjunct';
import { createSelector } from 'reselect';

const getAuth = r.prop('auth');

export const getToken = r.pipe(getAuth, r.prop('token'));

export const getCurrentUser = createSelector(
  r.pipe(getAuth, r.prop('currentUser')),
  r.when(
    ra.isNotNil,
    ra.renameKeys({
      User: 'id',
      Name: 'name',
      IsVerified: 'isEmailVerified',
      Token: 'token',
      Roles: 'roles',
      Publishers: 'publishers',
      CustomFields: 'customFields',
    })
  )
);

export const getCurrentUserEmail = r.pipe(getAuth, r.prop('userEmail'));

export const getCurrentUserRoles = createSelector(
  getCurrentUser,
  r.when(
    ra.isNotNil,
    r.pipe(r.propOr('', 'roles'), r.split(','), r.reject(r.isEmpty), r.map(r.trim))
  )
);

export const getIsCurrentUserProfilePublished = createSelector(
  getCurrentUser,
  (user) => !!user.customFields.find(({ Name, Value }) => Name === 'RequestedPublish' && Value)
);

const createRoleSelector = (role) =>
  createSelector(getCurrentUserRoles, r.ifElse(ra.isNotNil, r.includes(role), r.always(false)));

export const getIsCurrentUserAdmin = createRoleSelector('cs_admin');
export const getIsCurrentUserArtist = createRoleSelector('artist');
export const getIsCurrentUserModerator = createRoleSelector('moderator');
export const getIsCurrentUserHrManager = createRoleSelector('hr_manager');

export const getApiKey = r.pipe(getAuth, r.prop('apiKey'));
export const getSelectedPublisherId = r.pipe(getAuth, r.prop('selectedPublisherId'));

export const getDeviceId = r.pipe(getAuth, r.prop('deviceId'));
